// Copyright (c) StrangeBee 2023

import React, { ReactElement, ReactNode } from 'react';
import { Space } from 'antd';
import { classList } from '@Helpers/className';

import './IconLabel.scss';

interface IconLabelProps {
    icon?: ReactNode;
    label?: string | ReactElement;
    className?: string;
    textAlign?: 'left' | 'right';
}

const IconLabel = ({ icon, label = '', className = '', textAlign = 'left' }: IconLabelProps): ReactElement => {
    return (
        <Space className={classList('icon-label', className)}>
            {icon && <div className="iconlabel_icon">{icon}</div>}
            {label && (
                <div className={`iconlabel_label ${textAlign}`}>
                    <span>{label}</span>
                </div>
            )}
        </Space>
    );
};

export default IconLabel;
